export const VISIBLE_EVENT_CATEGORIES = Object.freeze([
  "Religion",
  "Podcast",
  "Education",
  "Influencer",
  "Comedy",
  "Music",
]);

export const PODCAST_STYLE_EVENT_CATEGORIES = Object.freeze([
  "Podcast",
  "Influencer",
  "Comedy",
  "Music",
]);

export const EVENT_EXPERIENCES = Object.freeze({
  Religion: Object.freeze({
    chatMode: "open",
    chatLabel: "ShowMeCongregation",
    chatDescription: "Let everyone join the congregation conversation",
    chatPlaceholder: "Share with the congregation…",
    moneyLabel: "ShowMeDonations",
    tipsLabel: "ShowMeTithes",
    tipSingular: "Tithe",
    tipsOptional: false,
    reactionsLabel: "ShowMeLiveChurch",
    questionsOnly: false,
    liveTipIdentity: false,
  }),
  Podcast: Object.freeze({
    chatMode: "open",
    chatLabel: "ShowMeFans",
    chatDescription: "Let fans join the live conversation",
    chatPlaceholder: "Share with the fans…",
    moneyLabel: "ShowMeMoney",
    tipsLabel: "ShowMeTips",
    tipSingular: "Tip",
    tipsOptional: true,
    reactionsLabel: "ShowMeLove",
    questionsOnly: false,
    liveTipIdentity: true,
  }),
  Education: Object.freeze({
    chatMode: "questions_only",
    chatLabel: "ShowMeHands",
    chatDescription: "Private messages visible only to the viewer and creator",
    chatPlaceholder: "Message the creator privately…",
    moneyLabel: "ShowMeMoney",
    tipsLabel: "ShowMeTips",
    tipSingular: "Tip",
    tipsOptional: true,
    reactionsLabel: "ShowMeClass",
    questionsOnly: true,
    liveTipIdentity: true,
  }),
  Influencer: Object.freeze({
    chatMode: "open",
    chatLabel: "ShowMeFans",
    chatDescription: "Let fans join the live conversation",
    chatPlaceholder: "Share with the fans…",
    moneyLabel: "ShowMeMoney",
    tipsLabel: "ShowMeTips",
    tipSingular: "Tip",
    tipsOptional: true,
    reactionsLabel: "ShowMeLove",
    questionsOnly: false,
    liveTipIdentity: true,
  }),
  Comedy: Object.freeze({
    chatMode: "open",
    chatLabel: "ShowMeFans",
    chatDescription: "Let fans join the live conversation",
    chatPlaceholder: "Share with the fans…",
    moneyLabel: "ShowMeMoney",
    tipsLabel: "ShowMeTips",
    tipSingular: "Tip",
    tipsOptional: true,
    reactionsLabel: "ShowMeLove",
    questionsOnly: false,
    liveTipIdentity: true,
  }),
  Music: Object.freeze({
    chatMode: "open",
    chatLabel: "ShowMeFans",
    chatDescription: "Let fans join the live conversation",
    chatPlaceholder: "Share with the fans…",
    moneyLabel: "ShowMeMoney",
    tipsLabel: "ShowMeTips",
    tipSingular: "Tip",
    tipsOptional: true,
    reactionsLabel: "ShowMeLove",
    questionsOnly: false,
    liveTipIdentity: true,
  }),
});

export const getEventExperience = (category) => {
  const normalized = String(category || "").trim().toLowerCase();
  const canonical = VISIBLE_EVENT_CATEGORIES.find(
    (item) => item.toLowerCase() === normalized,
  );
  return EVENT_EXPERIENCES[canonical] || EVENT_EXPERIENCES.Religion;
};

export const getChatModeForCategory = (category) =>
  getEventExperience(category).chatMode;

export const isVisibleEventCategory = (category) =>
  VISIBLE_EVENT_CATEGORIES.some(
    (visibleCategory) => visibleCategory.toLowerCase() === String(category || "").trim().toLowerCase(),
  );

export const isPodcastStyleEventCategory = (category) =>
  PODCAST_STYLE_EVENT_CATEGORIES.some(
    (podcastStyleCategory) =>
      podcastStyleCategory.toLowerCase() === String(category || "").trim().toLowerCase(),
  );

export const getReactionProfileForCategory = (category) => {
  const categoryKey = String(category || "").trim().toLowerCase();
  if (categoryKey === "religion") return "church";
  if (categoryKey === "education") return "education";
  if (isPodcastStyleEventCategory(category)) return "podcast";
  return "default";
};

export const areReactionsAudienceVisible = (category) =>
  isVisibleEventCategory(category);

export const filterVisibleEvents = (events) =>
  (Array.isArray(events) ? events : []).filter((event) => isVisibleEventCategory(event?.category));
